module["exports"] = [
  "#####",
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/postcode.js
// module id = 766
// module chunks = 1